import React from 'react'
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load'
import { Link } from 'react-router-dom'
import {CLIENT_BASE_URL} from '../../actions'
// import NewsThumb from './NewsThumb.jpg'

export class NewsItem extends React.Component {
  constructor (props) {
    super(props)
    this.getLinkUrl = this.getLinkUrl.bind(this)
  }

  getThumbUrl (thumb) {
    return `${CLIENT_BASE_URL}${thumb}`
    // return `http://semanticvideo.net${thumb}`
  }

  getLinkUrl (id) {
    return `/noticia/${id}`
  }

  render () {
    const {grid_size, news} = this.props
    let clsname = 'col-sm-6 col-md-4 col-lg-4 movie-item'

    if (grid_size !== 3) {
      clsname = 'col-sm-6 col-md-3 col-lg-3 movie-item'
    }
    //  <p className='date'>{news.pretty_date}</p>
    return (
      <Link to={this.getLinkUrl(news.id)}>
        <div className={clsname}>
          <div className='img-container'>
            <LazyLoad offsetHorizontal={1000} offsetVertical={300}>
              <img className='thumb' src={this.getThumbUrl(news.thumb)} />
            </LazyLoad>
            <div className='thumb-ovr' />
          </div>
          <div className='details'>
            <p>{news.title}</p>
            <p>{news.summary}</p>
          </div>
        </div>
      </Link>
    )
  }
}

NewsItem.propTypes = {
  grid_size: PropTypes.number.isRequired,
  news: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    summary: PropTypes.string.isRequired,
    pretty_date: PropTypes.string.isRequired
  }).isRequired
}



// WEBPACK FOOTER //
// ./src/views/NewsView/NewsItem.js